export default {
    data: () => ({
        cancelledAndCompleted: [],
        otherEvents: [],
        sortedEvents: []
    }),
    methods: {
        filterEvents(events) {
            this.cancelledAndCompleted = events.filter(
                (event) => event.event_status === 4 || event.event_status === 5 || event.event_status === 6
            )
            this.otherEvents = events.filter((event) => event.event_status !== 4 && event.event_status !== 5)
            this.sortedEvents = [...this.otherEvents, ...this.cancelledAndCompleted]
            return this.sortedEvents
        }
    }
}
